import CryptoJS, { AES } from "crypto-js";

// Place the 'encryptData' function in your project
export const encryptPayload = (data, secretKey) => {
    const secret = secretKey || process.env.REACT_APP_SECRET_KEY;
    // console.log("encrypting payload", data);
    try {
        const encryptedData = AES.encrypt(
            JSON.stringify(data),
            secret
        ).toString();
        return encryptedData;
    } catch (error) {
        console.error("Error while encryptPayload", error);
        return error;
    }
};

// Place the 'decryptData' function in your project
export const decryptPayload = (encryptedData, secretKey) => {
    const secret = secretKey || process.env.REACT_APP_SECRET_KEY;
    // console.log("decrypting payload", encryptedData);
    try {
        const decryptedData = AES.decrypt(encryptedData, secret).toString(
            CryptoJS.enc.Utf8
        );
        return JSON.parse(decryptedData);
    } catch (error) {
        console.error("Error while DecryptPayload:", error);
        return error;
    }
};